(function () {
    var typed = '';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > 4) typed = typed.slice(-4);
        if (typed === 'dune') {
            typed = '';
            spawnWorm();
        }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/dune')) {
        setTimeout(spawnWorm, 700);
    }

    function spawnWorm() {
        if (document.querySelector('.dune-worm')) return;

        var wrap = document.createElement('div');
        wrap.className = 'dune-worm';
        wrap.innerHTML = '<svg viewBox="0 0 520 180" xmlns="http://www.w3.org/2000/svg" class="dune-worm-svg">'
            // Body segments (back to front)
            + '<ellipse cx="80"  cy="155" rx="38" ry="28" fill="#6b4c1e" opacity="0.9"/>'
            + '<ellipse cx="130" cy="130" rx="40" ry="30" fill="#7a5520"/>'
            + '<ellipse cx="185" cy="108" rx="42" ry="32" fill="#8a6025"/>'
            + '<ellipse cx="245" cy="90"  rx="44" ry="33" fill="#9a6b28"/>'
            + '<ellipse cx="308" cy="78"  rx="46" ry="34" fill="#a8742a"/>'
            + '<ellipse cx="372" cy="72"  rx="46" ry="34" fill="#b37c2c"/>'
            // Head
            + '<ellipse cx="430" cy="72"  rx="52" ry="42" fill="#7a5520"/>'
            // Mouth ring segments
            + '<path d="M390 72 Q430 30 470 72" fill="none" stroke="#4a3010" stroke-width="6" stroke-linecap="round"/>'
            + '<path d="M390 72 Q430 114 470 72" fill="none" stroke="#4a3010" stroke-width="6" stroke-linecap="round"/>'
            // Teeth top
            + '<path d="M400 60 L407 44 L414 60" fill="#c8a96e"/>'
            + '<path d="M418 52 L425 36 L432 52" fill="#c8a96e"/>'
            + '<path d="M436 50 L443 34 L450 50" fill="#c8a96e"/>'
            + '<path d="M454 56 L460 42 L466 56" fill="#c8a96e"/>'
            // Teeth bottom
            + '<path d="M400 84 L407 100 L414 84" fill="#c8a96e"/>'
            + '<path d="M418 90 L425 106 L432 90" fill="#c8a96e"/>'
            + '<path d="M436 92 L443 108 L450 92" fill="#c8a96e"/>'
            + '<path d="M454 86 L460 102 L466 86" fill="#c8a96e"/>'
            // Eye
            + '<circle cx="448" cy="58" r="8" fill="#1a0a00"/>'
            + '<circle cx="451" cy="55" r="3" fill="#ff6600" opacity="0.7"/>'
            // Sand particles
            + '<circle cx="490" cy="95"  r="2" fill="#c8a96e" opacity="0.6"/>'
            + '<circle cx="500" cy="85"  r="1.5" fill="#c8a96e" opacity="0.5"/>'
            + '<circle cx="505" cy="100" r="1"   fill="#c8a96e" opacity="0.4"/>'
            + '<circle cx="475" cy="110" r="1.5" fill="#c8a96e" opacity="0.5"/>'
            + '</svg>'
            + '<div class="dune-caption">شای-حلود</div>';

        document.body.appendChild(wrap);
        setTimeout(function () { wrap.remove(); }, 5500);
    }
})();
